import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth.jsx';
import Layout from './components/Layout.jsx';
import Login from './routes/Login.jsx';
import Register from './routes/Register.jsx';
import Dashboard from './routes/Dashboard.jsx';
import POList from './routes/POList.jsx';
import POForm from './routes/POForm.jsx';
import PODetail from './routes/PODetail.jsx';
import Subscriptions from './routes/Subscriptions.jsx';
import ConcessionsAdmin from './routes/ConcessionsAdmin.jsx';
import VendorsAdmin from './routes/VendorsAdmin.jsx';
import DepartmentsAdmin from './routes/DepartmentsAdmin.jsx';
import UsersAdmin from './routes/UsersAdmin.jsx';
import TrafficAdmin from './routes/TrafficAdmin.jsx';
import Settings from './routes/Settings.jsx';
import NotFound from './routes/NotFound.jsx';

function RequireAuth({ children }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') {
    return <div className="flex h-screen items-center justify-center text-zinc-500 text-sm">…</div>;
  }
  if (status !== 'authed') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user?.role !== 'ADMIN') {
    return <Navigate to="/purchase-orders" replace />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route element={<RequireAuth><Layout /></RequireAuth>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/purchase-orders" element={<POList />} />
        <Route path="/purchase-orders/new" element={<POForm />} />
        <Route path="/purchase-orders/:id" element={<PODetail />} />
        <Route path="/purchase-orders/:id/edit" element={<POForm />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/admin/concessions" element={<RequireAdmin><ConcessionsAdmin /></RequireAdmin>} />
        <Route path="/admin/vendors" element={<RequireAdmin><VendorsAdmin /></RequireAdmin>} />
        <Route path="/admin/departments" element={<RequireAdmin><DepartmentsAdmin /></RequireAdmin>} />
        <Route path="/admin/users" element={<RequireAdmin><UsersAdmin /></RequireAdmin>} />
        <Route path="/admin/traffic" element={<RequireAdmin><TrafficAdmin /></RequireAdmin>} />
        <Route path="/admin/settings" element={<RequireAdmin><Settings /></RequireAdmin>} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
